import { render } from "./BalconyIcon.vue?vue&type=template&id=349c1e24"
import script from "./BalconyIcon.vue?vue&type=script&lang=js"
export * from "./BalconyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__